import React from 'react';
export const MensajeAlerta=({mensajeTexto,estado}) =>{
    
    let msj=mensajeTexto;
   
    return (
        <>
        {
            (estado==true && msj!='') && 
            (<div className="alert alert-success">
            {msj}
            </div>)
            ||
            (estado==false && msj!='') && 
            (<div className="alert alert-danger">
            {msj}
            </div>)

           

        }
        </>
        
    );
}